var __rspack_ns_object = JSON.parse('{"errorList":[{"parameter":"bic","code":"InvalidBic","message":"Bic length must be 8 or 11"}]}')